import script from "./SliderPrograms.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderPrograms.vue?vue&type=script&setup=true&lang=js"

import "./SliderPrograms.vue?vue&type=style&index=0&id=f33851aa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f33851aa"]])

export default __exports__